import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW9000Model } from '../kymw9000/kymw9000.model';
import { KYMW9005Model } from './kymw9005.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { KYMW9005InputModel } from './vo/kymw9005-input.model';
import { AuthoritySetIDModel } from '../kymw9000/vo/authority-set-id.model';
import { UserIDModel } from '../kymw9000/vo/user-id.model';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { NotNullTextAreaComponent } from '../../../commons/kymw02/not-null-text-area/not-null-text-area.component';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { GetAssociatedUserManagementDetailService } from './api-service/get-associated-user-management-detail.service'; 
import { GetAuthoritySetListService } from '../kymw9003/api-services/get-authority-set-list.service';
import { RegistAssociatedUserManagementService } from './api-service/regist-associated-user-management.service';
import { UpdateAssociatedUserManagementService } from './api-service/update-associated-user-management.service';
import { GetAssociatedUserTypeService } from '../kymw9000/api-services/get-associated-user-type.service';
import { CodeComboBoxComponent } from 'src/app/commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import { KYMW0400Component } from 'src/app/commons/kymw04/kymw0400/kymw0400.component';
import { KYMW0400OutputModel } from 'src/app/commons/kymw04/kymw0400/vo/kymw0400-output.model';
import { KYMW9010Component } from '../kymw9010/kymw9010.component';
import { KYMW9010OutputModel } from '../kymw9010/vo/kymw9010-output.model';
import { KYMW9000InputVO } from '../kymw9000/vo/kymw9000-input.model';
import { KYMW9003Model } from '../kymw9003/kymw9003.model';

/**
 * ユーザ情報詳細画面を管理するクラス
 *
 * @export KYMW9005Component
 * @class KYMW9005Component
 */
@Component({
  selector: 'app-kymw9005',
  templateUrl: 'kymw9005.component.html',
  styleUrls: ['kymw9005.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW9005Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw9005Model: KYMW9005Model = new KYMW9005Model();
  kymw9005InputModel: KYMW9005InputModel = new KYMW9005InputModel();
  // 受渡し情報
  private inputVo: KYMW9005InputModel = null;
  // 親画面への連携値
  outputVO: AuthoritySetIDModel = new AuthoritySetIDModel();

  kymw9000Model: KYMW9000Model = new KYMW9000Model();
  kymw9003Model: KYMW9003Model = new KYMW9003Model();
  kymw9010OutputVO: KYMW9010OutputModel = new KYMW9010OutputModel();

  // ユーザーID
  private associatedUserId: string = <string>'';
  // 権限セットID
  private authoritySetId: string = <string>'';

  @ViewChild('btn_Close', { static: true }) btn_Close: ElementRef;
  @ViewChild('cmb_userType', { static: true}) cmb_userType: CodeComboBoxComponent;
  @ViewChild('txt_emailAdress', { static: true }) txt_emailAdress: NotNullTextAreaComponent;

  // メールアドレスの活性制御
  public txt_emailAdressDisabled: boolean = <boolean>true;

  /** 表示モード
   * Regist : 新規登録
   * Update : 更新
   */
  private displayMode: string = <string>'Regist';

  /** 登録・更新状態判定 */
  private isSubmitSuccess: boolean = <boolean>false;

  /**
   * Creates an instance of KYMW9005Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @memberof KYMW9005Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getAssociatedUserManagementDetailService: GetAssociatedUserManagementDetailService,
    private getAuthoritySetListService: GetAuthoritySetListService,
    private registAssociatedUserManagementService: RegistAssociatedUserManagementService,
    private updateAssociatedUserManagementService: UpdateAssociatedUserManagementService,
    private getAssociatedUserTypeService: GetAssociatedUserTypeService,
  ) {
    super(kymw00Model);
  }

  /**
  * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
  *
  * @param {*} param 受け渡すデータ
  * @memberof KYMW9005Component
  */
  public setInterfaceParam(param: any): void {
    this.inputVo = <KYMW9005InputModel>param;
    this.associatedUserId = this.inputVo.associatedUserId;
  }

  /**
   * 初期処理
   *
   * @memberof KYMW9005Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW9005';
    this.kymw9005Model.kymw9005Component = this;

    //編集フラグ初期化
    this.kymw9005Model.isEdited = false;

    // ユーザ区分取得
    this.getAssociatedUserTypeService.execute(this.kymw9000Model, ()=>{
      this.kymw9005Model.associatedUserTypeList = this.kymw9000Model.associatedUserTypeList;
      // 新規登録の場合、先頭データを初期値とする
      this.kymw9005Model.associatedUserType = this.kymw9005Model.associatedUserTypeList[0].associatedUserType;
    });

    // 権限コンボボックスデータ取得
    // 有効な権限のみ取得
    this.kymw9003Model.authorityStatus = '0';
    this.getAuthoritySetListService.execute(this.kymw9003Model, ()=>{
      // 取得データを受け取る
      this.kymw9005Model.authoritySetList = this.kymw9003Model.authoritySetList;

      if (!PlessViewUtilsSub.isEmpty(this.associatedUserId)) {
        // 詳細表示の時、ユーザー情報を取得する（ユーザー詳細取得後コンボの作成）
        this.kymw9005Model.associatedUserId = this.associatedUserId;
        this.getAssociatedUserManagementDetailService.execute(this.kymw9005Model, this.inputVo);
        this.displayMode = 'Update'
      } else {
        // 新規登録の時、権限の初期値は先頭行にする
        this.kymw9005Model.authoritySetId = this.kymw9005Model.authoritySetList[0].authoritySetId;
        this.txt_emailAdressDisabled = false;
        this.displayMode = 'Regist';
      }
    }); 
  }

  /**
   * 権限セットID取得
   *
   * @returns {string} 権限セットID
   * @memberof KYMW9005Component
   */
  public getAuthoritySetId(): string {
    return this.authoritySetId;
  }

  /**
   * 検索ボタン押下時
   */
  public eventSearchAssociatedCompany_CLICKHandler():void {
    if (this.kymw9005Model.associatedUserType === KYMW00Model.ASSOCIATED_USER_TYPE_SUPPLIER) {
      // ユーザ区分が「取引先(卸)」の時、「取引先一覧」を表示
      const componentRef = this.dialogService.openModal(KYMW0400Component);
      const instance = componentRef.componentInstance as KYMW0400Component;
      instance.parent = this;
      instance.setKYMW0400Parameter = (outputVO: KYMW0400OutputModel) => this.setKYMW0400Parameter(outputVO);
      instance.closeFunction = () => {
        componentRef.close();
      };

    } else if (
      this.kymw9005Model.associatedUserType === KYMW00Model.ASSOCIATED_USER_TYPE_STUDIO || 
      this.kymw9005Model.associatedUserType === KYMW00Model.ASSOCIATED_USER_TYPE_PRODUCTION ) {
      // ユーザ区分が「スタジオ」の時、スタジオモードの「関連会社一覧」を表示
      // ユーザ区分が「制作会社」の時、制作会社モードの「関連会社一覧」を表示
      const componentRef = this.dialogService.openModal(KYMW9010Component);
      const instance = componentRef.componentInstance as KYMW9010Component;
      instance.parent = this;
      instance.setInterfaceParam(this.kymw9005Model.associatedUserType);
      instance.setKYMW9010Parameter = (outputVO: KYMW9010OutputModel) => this.setKYMW9010Parameter(outputVO);
      instance.closeFunction = () => {
        componentRef.close();
      };
    }
  }

  /**
   * 取引先一覧での選択データ取得
   * 
   */
  public setKYMW0400Parameter(outputVO: KYMW0400OutputModel) {
    if (this.kymw9005Model.associatedCompanyId !== outputVO.supplierCode
      || this.kymw9005Model.associatedCompanyName !== outputVO.supplierNameKanji) {
      this.eventEditHandler();
    }
    this.kymw9005Model.associatedCompanyId = outputVO.supplierCode;
    this.kymw9005Model.associatedCompanyName = outputVO.supplierNameKanji;
  }

  /**
   * 関連会社一覧での選択データ取得
   * 
   */
  public setKYMW9010Parameter(outputVO: KYMW9010OutputModel) {
    if (this.kymw9005Model.associatedCompanyId !== outputVO.associatedCompanyId
      || this.kymw9005Model.associatedCompanyName !== outputVO.associatedCompanyName) {
      this.eventEditHandler();
    }
    this.kymw9005Model.associatedCompanyId = outputVO.associatedCompanyId;
    this.kymw9005Model.associatedCompanyName = outputVO.associatedCompanyName;
  }

  /**
   * 設定ボタン押下時
   */
  public eventRegistUser_CLICKHandler(): void {
    /** 氏名(漢字)
     * ひらがな・カタカナ・漢字・空白以外の文字が含まれているか */
    const kanjiCheck = /[^\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Han}ー\uFF65-\uFF9F\s]/u;
    /** 氏名(かな)
     * 全角かな・空白のみで構成されているか */
    const kanaCheck = /^[\u3040-\u309F\s]+$/;
    /** メールアドレスの正規表現
     * 「@マーク1つ以上」「"."文字で終わらないドメインが入力されている」ことを確認  */
    const emailCheck = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
    
    // 入力必須項目チェック
    if (this.kymw9005Model.associatedCompanyName === "" ||
        this.kymw9005Model.associatedUserName === "" ||
        this.kymw9005Model.associatedUserNameKana === "" ||
        this.kymw9005Model.emailAddress === ""){
      this.dialogService.openAlert("未入力の項目があります。", "E");
      return;

    } else if ( kanjiCheck.test(this.kymw9005Model.associatedUserName) ||
       !kanaCheck.test(this.kymw9005Model.associatedUserNameKana) ) {
        // 氏名(漢字) 文字種チェック
        // 氏名(かな) 全角かなチェック
      this.dialogService.openAlertGetMessage("E0591");
      return;

    } else if ( !emailCheck.test(this.kymw9005Model.emailAddress) ) {
      // メールアドレス形式チェック
      this.dialogService.openAlertGetMessage("E0592");
      return;

    } else {
      this.dialogService.openAlertGetMessage("Q0192", [""],
        (closeDetail) => {
          if (closeDetail === PlessAlert.Yes) {
            if (this.kymw9005Model.associatedUserId) {
              //　更新の時
              this.updateAssociatedUserManagementService.execute(this.kymw9005Model, ()=>{
                this.dialogService.openAlertGetMessage('I0520');
                this.kymw9005Model.isEdited = false;
                this.isSubmitSuccess = true;
              });
            } else {
              // 新規登録の時
              this.registAssociatedUserManagementService.execute(this.kymw9005Model, (data)=>{
                this.dialogService.openAlertGetMessage("I0519");
                this.txt_emailAdressDisabled = true;
                this.kymw9005Model.isEdited = false;
                this.isSubmitSuccess = true;
                this.kymw9005Model.associatedUserId = data.AssociatedUserID;
              });
            }
            
          }
        }
      )
    }
  }

  /**
   * 編集フラグ
   * 
   */
  public eventEditHandler() {
    this.kymw9005Model.isEdited = true;
  }

  /**
   * ユーザ区分変更時
   * 
   */
  public eventUserType_CHANGEHandler():void {
    // 所属をクリア
    this.kymw9005Model.associatedCompanyName = ""
    this.eventEditHandler();
  }

  /**
   * 閉じるボタン押下時
   * 
   */
  public eventClose_CLICKHandler() {
    // 編集中または、新規登録時は値の変更をされていない時も確認ダイアログを開く
    if ( this.kymw9005Model.isEdited || ( this.displayMode === 'Regist' && !this.isSubmitSuccess )) {
      this.dialogService.openAlert("入力内容を破棄します。よろしいでしょうか。", "Q", 
        [PlessAlert.No, PlessAlert.Yes],
        (closeDetail) => {
          if (closeDetail === PlessAlert.Yes) {
            // 閉じる
            this.closeFunction(this);
          }
        }
      );
    } else {
      // 閉じる
      this.closeFunction(this);
    }
  }
}
